export interface StepType {
  visible?: boolean;
  visibleIndex: number;
  imageSrc?: string;
  iconSrc?: string;
  title?: string;
  description: string;
  buttons: {
    left?: StepButtonType;
    right?: StepButtonType;
  };
}

export interface StepButtonType {
  text: string;
  action: () => void;
}

export enum StorageKeys {
  FirstDeviceLogin = 'firstDeviceLogin',
}
